import './styles/JobOfferItem.scss';

import { Schedule, AttachFile } from '@mui/icons-material';
import { Grid, Paper, Divider, Chip } from '@mui/material';

import clsx from 'clsx';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import Logo from 'app/components/Logo';
import { translations } from 'locales/i18n';
import { JobOffering } from 'types/AppTypes';

interface Props {
  jobOffer: JobOffering;
  dense?: boolean;
  withId?: boolean;
  selected?: boolean;
  hideCourses?: boolean;
}

export const JobOfferItem: FunctionComponent<Props> = ({
  jobOffer,
  dense,
  withId,
  selected,
  hideCourses
}) => {
  const { t } = useTranslation();
  return (
    <Grid
      component={Paper}
      className={clsx('joboffer__body', {
        'joboffer__body--dense': dense,
        'joboffer__body--inactive': dense && !jobOffer.isActive,
        'joboffer__body--selected': selected
      })}
      elevation={3}
    >
      <Grid container justifyContent="space-between">
        <Grid item xs={3} className="logo">
          {!dense && <Logo path="jobmarket/logos" src={jobOffer.company.logo || ''} size="small" />}
        </Grid>
        {jobOffer.attachement && <AttachFile />}
      </Grid>
      {!hideCourses && (
        <Grid
          container
          className={clsx('joboffer__body__courses', {
            'joboffer__body__courses--dense': dense
          })}
        >
          {jobOffer.courses?.map(c => (
            <Chip
              key={c.id}
              className="joboffer__body__courses__course"
              label={c.shorthand}
              variant="outlined"
              color="primary"
              size="small"
            />
          ))}
        </Grid>
      )}
      <Grid container className="joboffer__body__title">
        {jobOffer.title}
      </Grid>
      {withId && (
        <Grid container className="joboffer__body__id">
          {withId && `ID: ${jobOffer.id}`}
        </Grid>
      )}
      <Grid container className="joboffer__body__type">
        {jobOffer.jobType.name} {!dense && `/${jobOffer.company.name}`}
      </Grid>
      {!dense && (
        <Grid container className="joboffer__body__place">
          {jobOffer.company.city}, {jobOffer.company.country}
        </Grid>
      )}
      <Grid container className="joboffer__body__start-date">
        <Schedule className="joboffer__body__start-date__icon" />
        <div style={{ fontWeight: 'normal', whiteSpace: 'pre' }}>
          {t(translations.pages.jobOffers.start()) + ':'}{' '}
        </div>
        {jobOffer.startDate}
      </Grid>
      {!dense && (
        <>
          <Divider />
          <Grid container className="joboffer__body__create-date">
            {t(translations.pages.jobOffers.updatedOn()) + ': '}
            {new Date(jobOffer.modifiedAt).toLocaleDateString()}
          </Grid>
        </>
      )}
      {!jobOffer.isActive && (
        <Grid container className="joboffer__body__inactive" justifyContent="flex-end">
          {t(translations.common.inactive())}
        </Grid>
      )}
    </Grid>
  );
};
